export const GET_PARAMETER_BACKUP_REQUEST = 'gatewayManagement/GET_PARAMETER_BACKUP_REQUEST';
export const GET_PARAMETER_BACKUP = 'gatewayManagement/GET_PARAMETER_BACKUP';
